import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const AnimationSlideRight = ({ children, duration,rootMargin }) => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
    rootMargin: rootMargin,
  });

  const isMobile = window.innerWidth <= 768;

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, x: isMobile ? 50 : 100 }} // Start out of view
      animate={inView ? { opacity: 1, x: 0 } : {}} // Animate into view
      transition={{ duration: duration, ease: "easeInOut" }}
    >
      {children}
    </motion.div>
  );
};
export default AnimationSlideRight